<template>
  <div>
    <customer-entity-add
      :is-active="isModalActive"
      :is-add="isAdd"
      :action="action"
      :edit-object-name="editObjectName"
      @confirm="editConfirm"
      @cancel="editCancel"
    />
    <div class="level no-margin">
      <div class="level-left">
        <h2 class="subtitle">Local Entity Information</h2>
      </div>
      <div class="level-right" v-if="!entityAction">
        <div class="level-item-horizontal">
          <ul class="context-options-right">
            <li>
              <a @click.prevent="addModal">New Entity</a>
            </li>
            <li>
              <a @click.prevent="deactivateSelected">Deactivate</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <circul8-table
      :records="entities"
      :fields="computedColumns"
      :routeNext="false"
      :usePropRecords="true"
      @clickcheck="checkCheckBox"
      :checkedRows="checkedRows"
      @clickEdit="editModal"
      @clickView="viewModal"
      :showRemoveButton="showDelete"
      :showEditButton="showEdit"
      :isCheckable="!entityAction"
      :newTableHeight="200"
    />
  </div>
</template>

<script>
import CustomerEntityAdd from "@/components/Customers/CustomerEntityAdd";
import utilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import Circul8Table from "../../components/Circul8Table.vue";
// @group Customers
export default {
  name: "CustomerEntity",
  mixins: [UserPermissionMixin, utilityMixin, ScopeMixin],
  components: { CustomerEntityAdd, Circul8Table },
  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    entities: {
      type: Array
    },
    entityAction: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isModalActive: false,
      isAdd: false,
      action: null,
      editObject: null,
      isLoading: false,
      paginated: false,
      perPage: 10,
      checkedRows: [],
      switchCustomerViewEnabled: false,
      switchCustomerId: null,
      columns: [
        {
          field: "name",
          label: "Entity Name",
          sticky: true
        },
        {
          field: "crm_id",
          label: "CRM ID",
          excludeForExternal: true
        },
        {
          field: "id",
          label: "Id"
        },
        {
          field: "address",
          label: "Address"
        },
        {
          field: "entity_country",
          label: "Country"
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions"
        }
      ]
    };
  },
  computed: {
    editObjectName() {
      if (this.editObject) {
        return this.editObject;
      }

      return this.getClearFormObject();
    },
    computedColumns() {
      // Report tracker table columns differ for internal and external users
      if (this.userExternalCheck() || this.switchCustomerViewEnabled) {
        // return this.columns.filter((col) => !col.excludeForExternalUser);
        const newColumns = [];
        this.columns.forEach(col => {
          if (!col.excludeForExternal) {
            newColumns.push(col);
          }
        });
        return newColumns;
      } else {
        return this.columns;
      }
    }
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    this.fetchCountries();
    this.disableActionItem();
    this.showDelete = false;
  },
  methods: {
    checkCheckBox(d) {
      this.checkedRows = d;
    },

    getClearFormObject() {
      return {
        name: null,
        crm_id: null,
        address: null,
        entity_country: null
      };
    },
    addModal() {
      this.isAdd = false;
      this.action = "Add";
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.isAdd = false;
      this.action = "Update";
      this.editObject = editObject;
      this.isModalActive = true;
    },
    viewModal(editObject) {
      this.isAdd = true;
      this.action = "View";
      this.editObject = editObject;
      this.isModalActive = true;
    },
    deactivateSelected() {
      if (this.checkedRows.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please choose at least one entity",
          type: "is-danger"
        });

        return false;
      }
      const entities = this.checkedRows.map(records => records.id);
      this.$emit("deactivate", entities);
    },
    editConfirm(data) {
      data["entity_country"] = this.countryMap[data["entity_country_id"]];
      if (this.action == "Add") {
        data["actions"] = true;
        this.entities.push(data);
      }
      this.isModalActive = false;

      // Below emit will pass the entity table data to customer add form so that it can be used to prepare payload
      this.$emit("confirm", this.entities);
    },
    editCancel() {
      this.isModalActive = false;
    }
  }
};
</script>
